// extracted by mini-css-extract-plugin
module.exports = {"customToggleText":"accordion-item-module--customToggleText--1FEsa","inlineTable":"accordion-item-module--inlineTable--1OM1q"};